import { apiSlice } from "@/services/api-slice";
import { ProductsMovements, CreateProductsMovements, AdjustmentReason, MovementsRequest } from "./movements.interface";
import { APIResponse } from "@/types/custom-http";


export const movementsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener todos los movimientos
      getProductsMovements: builder.query<APIResponse<{page: number; size: number; total: number; totalPages: number; movimientos: ProductsMovements[]}>, MovementsRequest>({
        query: (params) => {
          const finalParams: MovementsRequest = {
            page: params.page,
            size: params.size,
          };

          if (params.fecha_inicio !== undefined) {
            finalParams.fecha_inicio = params.fecha_inicio;
          }

          if (params.fecha_fin !== undefined) {
            finalParams.fecha_fin = params.fecha_fin;
          }

          if (params.product_id) {
            finalParams.product_id = params.product_id;
          }

          if (params.user_code) {
            finalParams.user_code = params.user_code;
          }

          if (params.origin_location_id) {
            finalParams.origin_location_id = params.origin_location_id;
          }

          if (params.destination_location_id) {
            finalParams.destination_location_id = params.destination_location_id;
          }

          return {
            url: "auth/warehouse/movements",
            params: finalParams,
          };
        },
        providesTags: ["Movements"],
      }),

      // Obtener todos los motivos de ajustes
      getAdjustmentsReasons: builder.query<APIResponse<AdjustmentReason[]>, void>({
        query: () => ({
          url: "auth/warehouse/movements/reasons"
        }),
        providesTags: ["Movements"],
      }),

      // Crear un nuevo usuario
      createProductsMovements: builder.mutation<APIResponse<ProductsMovements>, CreateProductsMovements>({
        query: (user) => ({
          url: 'auth/warehouse/movements',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Movements'],
      }),

    }),
  });
  
  export const {
    useGetProductsMovementsQuery,
    useLazyGetProductsMovementsQuery,
    useGetAdjustmentsReasonsQuery,
    useCreateProductsMovementsMutation
  } = movementsApi;